import { useUserOrgData } from '#pplx/frontend/apps/ask/organization/hooks/useUserOrgData.js';
import { useIsEnterpriseUser } from '#pplx/frontend/auth/useIsEnterpriseUser.js';
export function useBrowserAgentDisabledByOrg() {
    const isEnterpriseUser = useIsEnterpriseUser();
    const { organization } = useUserOrgData({
        reason: 'useBrowserAgentDisabledByOrg',
    });
    if (!isEnterpriseUser) {
        return false;
    }
    return organization?.settings?.comet_agentic_actions_allowed === false;
}
//# sourceMappingURL=useBrowserAgentDisabledByOrg.js.map